import { memo } from 'react';
import { Dialog, DialogActions, DialogButton, DialogDescription, DialogTitle } from '~/components/ui/LegacyDialog';
import type { OrganizationData } from '~/types/organization';

interface SwitchAccountDialogProps {
  open: boolean;
  onSwitch: (organization: OrganizationData) => void;
  onClose: VoidFunction;
  activeOrganization: OrganizationData | null;
  projectOrganization: OrganizationData | null;
}

export const SwitchAccountDialog = memo<SwitchAccountDialogProps>(
  ({ open, onSwitch, onClose, projectOrganization, activeOrganization }) => {
    if (projectOrganization === null) {
      return null;
    }

    return (
      <Dialog open={open} maxWidth={600} showCloseButton={true} onClose={onClose}>
        <DialogTitle>Switch account</DialogTitle>
        <DialogDescription>
          <p className="mb-4">
            This project belongs to <span className="font-semibold">{projectOrganization.name}</span>. Would you like to
            stay on {activeOrganization ? activeOrganization.name : 'your personal account'} or switch to{' '}
            {projectOrganization.name}?
          </p>
          <p>We will use the tokens of the selected account.</p>
        </DialogDescription>
        <DialogActions>
          <DialogButton onClick={onClose} variant="secondary">
            Stay on current account
          </DialogButton>
          <DialogButton onClick={() => onSwitch(projectOrganization)} variant="primary">
            Switch
          </DialogButton>
        </DialogActions>
      </Dialog>
    );
  },
);

SwitchAccountDialog.displayName = 'SwitchAccountDialog';
